import React from 'react';
import { About_IMG } from '../Constants/ImageConstants';
import AboutSection from '../Feature/Aboutus/AboutSection';
import MotionImageSection from '../Feature/Aboutus/MotionImageSecttion';
import BannerSection from '../Feature/Common/BannerSection';

// Define functional component for Home page
const About: React.FC = () => {

const data = {
  title: "About",
  description: "Grassroots Sports ",
  image: About_IMG.aboutBanner,
  buttonText: "Learn More",
  buttonLink: "/about"
};


  return (
    < >
      <BannerSection data={data} />
      <AboutSection  />
      <MotionImageSection/>
    </>
  );
};

export default About;
